import { Inject, Injectable } from '@angular/core';
import type { CanMatch } from '@angular/router';
import { MerchantService, type OdinFeatures } from '@odin/odin-core';

export const NEW_TRANSACTION_EXPERIENCE_TOGGLE = 'new-transaction-experience';

/**
 * Matches the transaction detail route to the rebuilt page only where the
 * 'new-transaction-experience' environment toggle is on and the user has
 * opted in through their UI defaults, otherwise the legacy page serves the
 * same path. The new page depends on the Portal BFF detail endpoint, so the
 * toggle must only be enabled in environments where that endpoint is deployed.
 */
@Injectable({ providedIn: 'root' })
export class NewTransactionDetailGuard implements CanMatch {
  constructor(
    private merchantService: MerchantService,
    @Inject('features') private features: OdinFeatures) { }

  canMatch(): boolean {
    if (!this.features[NEW_TRANSACTION_EXPERIENCE_TOGGLE]) return false;

    return this.merchantService.getUserprofile()?.uiDefaults?.newTransactionExperience === true;
  }
}
